import { render } from "./GRange.vue?vue&type=template&id=f9d10728&scoped=true"
import script from "./GRange.vue?vue&type=script&lang=js"
export * from "./GRange.vue?vue&type=script&lang=js"

import "./GRange.vue?vue&type=style&index=0&id=f9d10728&scoped=true&lang=css"
import "./GRange.vue?vue&type=style&index=1&id=f9d10728&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9d10728"]])

export default __exports__